import { render, staticRenderFns } from "./view-shop-list.vue?vue&type=template&id=3c607a24&scoped=true&"
import script from "./view-shop-list.vue?vue&type=script&lang=js&"
export * from "./view-shop-list.vue?vue&type=script&lang=js&"
import style0 from "./view-shop-list.vue?vue&type=style&index=0&id=3c607a24&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c607a24",
  null
  
)

export default component.exports